import { Box, Grid, Link, Typography } from "@mui/material";

export const GridItem: React.FC<{
  label: string;
  value: string | number | null;
  href?: string;
}> = (props) => {
  const { label, value, href } = props;
  return (
    <>
      <Grid
        item
        sm={12}
        md={12}
        lg={6}
        // mx={1}
        sx={{ borderBottom: "1px solid #f0f0f0" }}
      >
        <Box
          display="flex"
          sx={{ paddingLeft: "5px" }}
          justifyContent={"space-between"}
        >
          <Typography color="textSecondary" variant="h6" fontWeight="700">
            {label}
          </Typography>
          {href && (
            <Typography
              color="textSecondary"
              sx={{ width: "50%", display: "flex", justifyContent: "end" }}
              variant="h6"
              fontWeight="400"
            >
              <Link href={href} target="_blank">
                {value}
              </Link>
            </Typography>
          )}
          {!href && (
            <Typography
              color="textSecondary"
              sx={{ width: "50%", display: "flex", justifyContent: "end" }}
              variant="h6"
              fontWeight="400"
            >
              {!value || value.toString().length === 0 ? "--" : value}
            </Typography>
          )}
        </Box>
      </Grid>
    </>
  );
};
